import { render, staticRenderFns } from "./ECommerceAdd.vue?vue&type=template&id=18eb1b9a&scoped=true&"
import script from "./ECommerceAdd.vue?vue&type=script&lang=js&"
export * from "./ECommerceAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18eb1b9a",
  null
  
)

export default component.exports